import React, { useEffect } from "react";
import InputText from "../../../common/Input/InputText";
import Select from "react-select";
import { getAllLabReport } from "../../../../store/slices/labReportSlice";
import { useDispatch, useSelector } from "react-redux";
import styles from "../editLabReport.module.scss";
import classNames from "classnames";
import { getAllRegisteredUnregisteredClinic } from "../../../../store/slices/clinicSlice";
import UrineRMProfile from "./UrineRMProfile";
import StoolRMProfile from "./StoolRMProfile";
import DengueProfile from "./dengueFormat";
import SynovialFluidProfile from "./SynovialFluidFormart";
import PeripheralSmearProfile from "./textareaprofile";
import FnacProfile from "./FnacProfile";
import WidalProfile from "./WidalProfile";
import SemenAnalysisProfile from "./SemenAnalysisProfile";
import CBCProfile from "./cbcProfile";
import AboutGroupTestProfile from "./abogroup";
const TestAndProfile = ({
  newLabReport,
  labReportFormData,
  unmatchedTests,
  handleTestProfileChange,
  selectAllOutsource,
  setSelectAllOutsource,
  isOwner,
  loggedInClinicId,
}) => {
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const labReportId = sessionStorage.getItem("labReportId");
  const { registeredUnregisteredClinic } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const isSputumCulture = (profileName) =>
    profileName?.toLowerCase().includes("sputum culture & sensitivity") ||
    profileName?.toLowerCase().includes("urine culture & sensitivity") ||
    profileName?.toLowerCase().includes("e/t tube culture") ||
    profileName?.toLowerCase().includes("pus culture") ||
    profileName?.toLowerCase().includes("stool culture & sensitivity");

  useEffect(() => {
    dispatch(getAllLabReport({ clinicId, id: labReportId, token }));
    dispatch(getAllRegisteredUnregisteredClinic({ token }));
  }, [dispatch, clinicInfo, labReportId, token]);

  const method = [
    { value: "RAPID KIT", label: "RAPID KIT" },
    { value: "ELISA", label: "ELISA" },
    { value: "CLIA", label: "CLIA" },
    { value: "ECLIA", label: "ECLIA " },
    { value: "Immunoturbidimetric", label: "Immunoturbidimetric" },
    {
      value: "Glucose oxidase (GOD)-Peroxidase(POD)",
      label: "Glucose oxidase (GOD)-Peroxidase(POD)",
    },
    { value: "Bromo cresol Green (BCG)", label: "Bromo cresol Green (BCG)" },
    { value: "Calculated", label: "Calculated" },
    { value: "DIAZO", label: "DIAZO" },
    { value: "CHOD-PAP", label: "CHOD-PAP" },
    { value: "Jaffe", label: "Jaffe" },
    { value: "Biuret End Point", label: "Biuret End Point" },
    {
      value: "Glycerol Phosphate Oxidase (GPO) and Peroxidase (POD)",
      label: "Glycerol Phosphate Oxidase (GPO) and Peroxidase (POD)",
    },
    { value: "Urease - POD", label: "Urease - POD" },
    { value: "Uricase - POD", label: "Uricase - POD" },
    { value: "Non-cyanide", label: "Non-cyanide" },
    { value: "Electrical Impedance", label: "Electrical Impedance" },
    {
      value: " Electrical Impedance/Leishmans stain and Microscopy",
      label: " Electrical Impedance/Leishmans stain and Microscopy",
    },
  ];
  const cbcMethods = [
    {
      value: " Electrical Impedance / Microscopy-Leishman Stain",
      label:
        "Electrical Impedance Electrical Impedance / Microscopy-Leishman Stain",
    },
    {
      value: "Electrical Impedance/Sahils method",
      label: "Electrical Impedance/Sahils method",
    },
    { value: "Electrical Impedance", label: "Electrical Impedance" },
    { value: "Calculated", label: "Calculated" },
    { value: "Non-Cyanide", label: "Non-Cyanide" },
  ];
  const lipidProfileMethods = [
    { value: "CHOD-PAP", label: "CHOD-PAP" },
    { value: "GPO-POD End Point", label: "GPO-POD End Point" },
    { value: "Selective", label: "Selective" },
    { value: "Calculated", label: "Calculated" },
  ];
  const lftMethods = [
    { value: "DIAZO", label: "DIAZO" },
    { value: "Tris buffer IFCC", label: "Tris buffer IFCC" },
    { value: "AMP p-NPP", label: "AMP p-NPP" },
    { value: "Biuret End Point", label: "Biuret End Point" },
    { value: "Bromocresol Green (BCG)", label: "Bromocresol Green (BCG)" },
    { value: "Calculated", label: "Calculated" },
    { value: "SZASZ", label: "SZASZ" },
  ];
  const kftMethods = [
    { value: "Urease - POD", label: "Urease - POD" },
    { value: "Jaffe", label: "Jaffe" },
    { value: "Ion-Selective Electrode", label: "Ion-Selective Electrode" },
  ];
  const hba1cMethods = [
    { value: "H.P.L.C", label: "H.P.L.C" },
    { value: "Calculated", label: "Calculated" },
  ];
  const cultureOptions = [
    {
      value: "Sugar by Hexokinase Method by Roche Cohas",
      label: "Sugar by Hexokinase Method by Roche Cohas",
    },
    {
      value:
        "Test Done By  Roche Cohas(III Fully Automated Biochemistry Analysis",
      label:
        "Test Done By  Roche Cohas(III Fully Automated Biochemistry Analysis",
    },
    {
      value: "Test Done By Fully Automated SMR FIBRAN 20 Coagulometer Analysis",
      label: "Test Done By Fully Automated SMR FIBRAN 20 Coagulometer Analysis",
    },
    {
      value: "Test Done By KirBy-Bauer Disk Diffusion",
      label: "Test Done By KirBy-Bauer Disk Diffusion",
    },
    {
      value: "Test Done By Roche 9180 Electolyte Analyse",
      label: "Test Done By Roche 9180 Electolyte Analyse",
    },
    {
      value: "Test Done By Roche Urisys Fully Automated Urine Analyse",
      label: "Test Done By Roche Urisys Fully Automated Urine Analyse",
    },
    {
      value: "Test Done On Automated Biochemistry Analyser",
      label: "Test Done On Automated Biochemistry Analyser",
    },
    {
      value: "Test Done On Fully Automated Cell Counter",
      label: "Test Done On Fully Automated Cell Counter",
    },
    {
      value: "Test Perfomed 'Nown ICT Binax",
      label: "Test Perfomed 'Nown ICT Binax",
    },
  ];
  const receivedStatus = [
    { value: "Hemolysis", label: "Hemolysis " },
    { value: "BloodClot", label: "BloodClot " },
    { value: "Less Sample", label: "Less Sample " },
    { value: "Wrong Vile", label: "Wrong Vile " },
    { value: "Fixed", label: "Fixed " },
    { value: "UnFixed", label: "UnFixed " },
    { value: "No Medical History", label: "No Medical History " },
  ];

  const reportingStatus = [
    { value: "Insufficiant Slide", label: "Insufficiant Slide " },
    { value: "More Patient History", label: "More Patient History " },
  ];

  const sourceType = [
    { value: "inHouse", label: "In House" },
    { value: "outSource", label: "Out Source" },
  ];
  const sampleTypeOptions = [
    { value: "EDTA Whole Blood", label: "EDTA Whole Blood" },
    { value: "Plasma", label: "Plasma" },
    { value: "Serum", label: "Serum" },
    { value: "Urine", label: "Urine" },
  ];
  const yesNoOptions = [
    { value: "No", label: "No" },
    { value: "Yes", label: "Yes" },
  ];
  const handleSourceTypeChange = (e, profileId, value, testId = null) => {
    handleTestProfileChange(e, "sourceType", profileId, testId);

    if (value === "inHouse") {
      setSelectAllOutsource(false);
    }
  };

  const testDataMap = labReportFormData?.tests?.reduce((acc, test) => {
    const key = test?.id || test?._id;
    if (key) {
      acc[key] = {
        ...test,
        isNABL: test?.isNABL || "No",
      };
    }
    return acc;
  }, {});

  const testMap = new Map();
  labReportFormData?.profiles?.forEach((profile) => {
    profile?.tests?.forEach((test) => {
      const key = test?.id || test?._id;

      testMap.set(key, {
        ...test,
        isNABL: test?.isNABL || "No",
      });
    });
  });

  const getProfileMethods = (profileName) => {
    const name = profileName?.toLowerCase();

    if (name === "cbc") {
      return cbcMethods;
    }

    if (name?.includes("lipid profile")) {
      return lipidProfileMethods;
    }
    if (name?.includes("Liver Function Test(LFT)") || name?.includes("lft")) {
      return lftMethods;
    }
    if (
      name?.includes(" Kidney Function Test(KFT)") ||
      name?.includes("kft") ||
      name?.includes("Renal Function Test (RFT)") ||
      name?.includes("rft")
    ) {
      return kftMethods;
    }
    if (name?.includes("hba1c")) {
      return hba1cMethods;
    }
    return method;
  };

  const rowStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "10px",
  };

  const labelStyle = {
    minWidth: "120px",
    fontWeight: "500",
    whiteSpace: "nowrap",
  };

  const textareaStyle = {
    width: "250px",
    padding: "6px 10px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "13px",
    resize: "none",
  };
  return (
    <div className={classNames(styles.testAndProfile, "card")}>
      <div className="card-body">
        {unmatchedTests &&
          unmatchedTests?.map((item, index) => {
            let highRange, lowRange;
            if (item?.patientId?.userId?.age?.year < 10) {
              highRange = item?.ihigh_range;
              lowRange = item?.ilow_range;
            } else {
              if (item?.patientId?.userId?.gender === "Male") {
                highRange = item.mhigh_range;
                lowRange = item.mlow_range;
              } else if (item.patientId?.userId?.gender === "Female") {
                highRange = item.fhigh_range;
                lowRange = item.flow_range;
              } else {
                highRange = item.high_range;
                lowRange = item.low_range;
              }
            }
            const testData = item?._id
              ? testDataMap && (testDataMap[item?._id] || {})
              : {};

            const isAboGroupTest = item?.testName
              ?.toLowerCase()
              .includes("abo group & rh type");
            if (isAboGroupTest) {
              return (
                <div key={index}>
                  <AboutGroupTestProfile
                    item={item}
                    testData={testData}
                     lowRange={lowRange}
                     highRange={highRange}
                       referenceRange={item?.reference_range_details}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                </div>
              );
            }
            const canEditTest =
              isOwner ||
              (item?.sourceType === "outSource" &&
                String(
                  item?.labForOutsource?._id ||
                    item?.unRegisteredlabForOutsource?._id,
                ) === String(loggedInClinicId));
            return (
              <div key={index}>
                <div className="d-flex align-items-center justify-content-between gap-4">
                  <h4 className="mb-4">Name : {item?.testName}</h4>
                  <div className="d-flex align-items-center gap-3">
                    {isOwner &&
                      sourceType?.map((status) => (
                        <div
                          key={`${status.value}_${item._id}`}
                          className="form-check custom-checkbox mb-3 ms-3 checkbox-info"
                        >
                          <input
                            type="radio"
                            className={classNames(
                              styles.checkbox,
                              "form-check-input",
                            )}
                            id={`${status.value}_${item._id}`}
                            name={`sourceType_${item._id}`}
                            value={status.value}
                            checked={
                              selectAllOutsource
                                ? status.value === "outSource"
                                : testData?.sourceType === status.value
                            }
                            onChange={(e) =>
                              handleSourceTypeChange(e, item._id, status.value)
                            }
                            disabled={!canEditTest}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${status.value}_${item._id}`}
                          >
                            {status.label}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div className={styles.testAndProfileWrapper}>
                  <div className={styles["inputWrapper"]}>
                    {!selectAllOutsource &&
                      testData?.sourceType === "outSource" && (
                        <div className="form-group" key={item._id}>
                          <label className="col-form-label">
                            Lab For Out Source:
                          </label>

                          <Select
                            name="outsourceLab"
                            placeholder="Select Lab"
                            value={{
                              value:
                                testData &&
                                (testData?.labForOutsource ||
                                  testData?.unRegisteredlabForOutsource),
                              label:
                                testData &&
                                (testData?.labForOutsourceName ||
                                  testData?.unRegisteredlabForOutsourceName),
                            }}
                            onChange={(e) =>
                              handleTestProfileChange(
                                e,
                                "labForOutsource",
                                item._id,
                              )
                            }
                            isDisabled={!canEditTest}
                            options={
                              registeredUnregisteredClinic &&
                              registeredUnregisteredClinic?.map((item) => ({
                                value: item._id,
                                label: item?.clinicName,
                              }))
                            }
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                maxHeight: "14rem",
                                overflowY: "auto",
                              }),
                            }}
                          />
                        </div>
                      )}
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group">
                      <InputText
                        value={item?.category?.categoryName}
                        readOnly={true}
                        label="Category"
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group" key={item._id}>
                      <InputText
                        value={item?.testMethod?.name}
                        readOnly={true}
                        label="Method"
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group" key={`sampleType_${item._id}`}>
                      <InputText
                        value={item?.testSampleType?.name}
                        readOnly={true}
                        label="Sample Type"
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group" key={item._id}>
                      <InputText
                        name="value"
                        value={testData && (testData?.value || "")}
                        onChange={(e) =>
                          handleTestProfileChange(e, "value", item._id)
                        }
                        className="lab-value"
                        label="Value"
                        readOnly={!canEditTest}
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group">
                      <label className="col-form-label">Is NABL Approved</label>

                      <Select
                        name="isNABL"
                        value={
                          yesNoOptions.find(
                            (option) => option.value === testData?.isNABL,
                          ) || yesNoOptions[0]
                        }
                        onChange={(e) =>
                          handleTestProfileChange(e, "isNABL", item._id)
                        }
                        options={yesNoOptions}
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group">
                      <InputText
                        readOnly={true}
                        label="Low Value"
                        value={lowRange}
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group">
                      <InputText
                        readOnly={true}
                        label="High Value"
                        value={highRange}
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group">
                      <InputText
                        value={item?.reference_range_details}
                        label="Reference Range"
                        readOnly={true}
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group">
                      <InputText
                        value={item?.units}
                        readOnly={true}
                        label="Units"
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group" key={item._id}>
                      <label className="col-form-label">Received Status:</label>
                      <Select
                        name="receivedStatus"
                        placeholder="Select Status"
                        value={{ label: testData && testData?.receivedStatus }}
                        onChange={(e) =>
                          handleTestProfileChange(e, "receivedStatus", item._id)
                        }
                        options={
                          receivedStatus &&
                          receivedStatus?.map((serviceMode) => ({
                            value: serviceMode.value,
                            label: serviceMode.label,
                          }))
                        }
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: "14rem",
                            overflowY: "scroll",
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div className={styles["inputWrapper"]}>
                    <div className="form-group" key={item._id}>
                      <label className="col-form-label">
                        Reporting Status:
                      </label>
                      <Select
                        name="reportingStatus"
                        placeholder="Select Status"
                        value={{ label: testData && testData?.reportingStatus }}
                        onChange={(e) =>
                          handleTestProfileChange(
                            e,
                            "reportingStatus",
                            item._id,
                          )
                        }
                        isDisabled={!canEditTest}
                        options={
                          reportingStatus &&
                          reportingStatus?.map((serviceMode) => ({
                            value: serviceMode.value,
                            label: serviceMode.label,
                          }))
                        }
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: "14rem",
                            overflowY: "auto",
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        {newLabReport &&
          newLabReport?.profiles?.map((profile, index) => {
            const isLipid = profile?.profileName
              ?.toLowerCase()
              .includes("lipid profile");
            const isHba1c = profile?.profileName
              ?.toLowerCase()
              .includes("hba1c");
            const isLFT =
              profile?.profileName
                ?.toLowerCase()
                .includes("liver function test") ||
              profile?.profileName?.toLowerCase().includes("lft");
            const getTestValue = (name) => {
              const target = name.toLowerCase().trim();
              const test = profile.tests.find((t) => {
                const tn = t.testName?.toLowerCase()?.trim() || "";
                if (tn === target) return true;
                if (
                  target === "hba1c" &&
                  (tn.includes("hba1c") ||
                    tn.includes("hemoglobin a1c") ||
                    tn.includes("haemoglobin a1c")) &&
                  !tn.includes("abg") &&
                  !tn.includes("average blood glucose")
                ) {
                  return true;
                }
                return false;
              });

              const updated = testMap.get(test?._id);

              return parseFloat(updated?.value || 0);
            };
            // Auto calculated lft
            const total = getTestValue("bilirubin total");
            const direct = getTestValue("bilirubin direct");

            const indirect2 = total - direct;
            const indirect = isNaN(indirect2) ? "" : indirect2.toFixed(2);
            const totalProtein = Number(getTestValue("total protein"));
            const albumin = Number(getTestValue("Albumin(ALB)"));
            const globulin = totalProtein - albumin;
            const globulin2 = isNaN(globulin) ? "" : globulin.toFixed(2);

            // ALB/GLB Ratio
            const agratio = globulin !== 0 ? albumin / globulin : 0;
            const agratio2 =
              isNaN(agratio) || !isFinite(agratio)
                ? ""
                : parseFloat(Math.round(agratio * 100) / 100).toFixed(1);

            //LIPID CALCULATIONS

            const cholesterol = getTestValue("cholesterol");
            const hdl = getTestValue("hdl");
            const tg =
              getTestValue("triglycerides(tg)") ||
              getTestValue("triglycerides");

            // VLDL
            const vldl = tg / 5;
            const vldl2 = isNaN(vldl) ? "" : vldl.toFixed(2);

            // LDL
            const ldl = cholesterol - hdl - tg / 5;
            const ldl2 = isNaN(ldl) ? "" : ldl.toFixed(2);

            // Ratios
            const cholHdl = hdl !== 0 ? (cholesterol / hdl).toFixed(2) : "";

            const ldlHdl = hdl !== 0 ? (ldl / hdl).toFixed(2) : "";

            const hba1c = getTestValue("hba1c");
            const abg =
              isHba1c && Number.isFinite(hba1c) && hba1c > 0
                ? (28.7 * hba1c - 46.7).toFixed(2)
                : "";

            // Auto Calculated
            const isUrineRM = profile?.profileName
              ?.toLowerCase()
              .includes("urine");
            const currentProfile = labReportFormData?.profiles?.find(
              (item) => item.id === profile._id,
            );
            const canEditProfile =
              isOwner ||
              String(
                currentProfile?.labForOutsource ||
                  currentProfile?.unRegisteredlabForOutsource,
              ) === String(loggedInClinicId);

            return (
              <div key={index}>
                <div className="d-flex align-items-center justify-content-between align-items-center gap-4">
                  <h4 className="mb-4">Name : {profile?.profileName}</h4>
                  {isSputumCulture(profile?.profileName) && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <label style={{ minWidth: "80px", fontWeight: "500" }}>
                        Method
                      </label>

                      <div style={{ width: "250px" }}>
                       <InputText
                        value={profile?.testMethod?.name}
                        readOnly={true}
                        label="Method"
                      />
                      </div>
                    </div>
                  )}
                  <div className="d-flex align-items-center gap-4">
                    <div style={{ width: "15rem" }}>
                      {!selectAllOutsource &&
                        currentProfile?.sourceType === "outSource" && (
                          <div className="form-group" key={profile._id}>
                            <Select
                              name="labForOutsource"
                              placeholder="Select Lab"
                              onChange={(e) =>
                                handleTestProfileChange(
                                  e,
                                  "labForOutsource",
                                  profile._id,
                                )
                              }
                              isDisabled={!isOwner}
                              value={{
                                label:
                                  currentProfile &&
                                  (currentProfile?.labForOutsourceName ||
                                    currentProfile?.unRegisteredlabForOutsourceName),
                                value:
                                  currentProfile &&
                                  (currentProfile?.labForOutsource ||
                                    currentProfile?.unRegisteredlabForOutsource),
                              }}
                              options={
                                registeredUnregisteredClinic &&
                                registeredUnregisteredClinic?.map((item) => ({
                                  value: item._id,
                                  label: item?.clinicName,
                                }))
                              }
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  maxHeight: "14rem",
                                  overflowY: "auto",
                                }),
                              }}
                            />
                          </div>
                        )}
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3">
                      {isOwner &&
                        sourceType?.map((status) => (
                          <div
                            key={`${status.value}_${profile._id}`}
                            className="form-check custom-checkbox mb-3 ms-3 checkbox-info"
                          >
                            <input
                              type="radio"
                              className={classNames(
                                styles.checkbox,
                                "form-check-input",
                              )}
                              id={`${status.value}_${profile._id}`}
                              name={`sourceType_${profile._id}`}
                              value={status.value}
                              checked={
                                selectAllOutsource
                                  ? status.value === "outSource"
                                  : currentProfile?.sourceType === status.value
                              }
                              onChange={(e) =>
                                handleSourceTypeChange(
                                  e,
                                  profile._id,
                                  status.value,
                                )
                              }
                              disabled={!canEditProfile}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`${status.value}_${profile._id}`}
                            >
                              {status.label}
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                {/* {profile?.tests &&
                  profile?.tests?.map((item, index) => {
                    const isCulture = isSputumCulture(profile?.profileName);
                    let highRange, lowRange;
                    if (item?.patientId?.userId?.age?.year < 10) {
                      highRange = item?.ihigh_range;
                      lowRange = item?.ilow_range;
                    } else {
                      if (item?.patientId?.userId?.gender === "Male") {
                        highRange = item.mhigh_range;
                        lowRange = item.mlow_range;
                      } else if (item.patientId?.userId?.gender === "Female") {
                        highRange = item.fhigh_range;
                        lowRange = item.flow_range;
                      } else {
                        highRange = item.high_range;
                        lowRange = item.low_range;
                      }
                    }
                    const testData = testMap.get(item._id) || {};
                    const canEditProfileTest =
                      isOwner ||
                      (item?.sourceType === "outSource" &&
                        String(
                          item?.labForOutsource?._id ||
                            item?.unRegisteredlabForOutsource?._id,
                        ) === String(loggedInClinicId)) ||
                      (profile?.sourceType === "outSource" &&
                        String(
                          profile?.labForOutsource?._id ||
                            profile?.unRegisteredlabForOutsource?._id,
                        ) === String(loggedInClinicId));
                    return (
                      <div className={styles.testAndProfileWrapper} key={index}>
                        {isCulture ? (
                          <>
                            <div className={styles["inputWrapper"]}>
                              <InputText
                                value={item?.testName}
                                label="Test Name"
                                readOnly={true}
                              />
                            </div>

                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <label className="col-form-label">Result</label>
                                <Select
                                  name="value"
                                  placeholder="Select Result"
                                  value={
                                    testData.value
                                      ? { label: testData.value }
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleTestProfileChange(
                                      e,
                                      "value",
                                      profile._id,
                                      item._id,
                                    )
                                  }
                                  isDisabled={!canEditProfileTest}
                                  options={[
                                    { value: "SENSITIVE", label: "SENSITIVE" },
                                    {
                                      value: "INTERMEDIATE",
                                      label: "INTERMEDIATE",
                                    },
                                    { value: "RESISTANT", label: "RESISTANT" },
                                  ]}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  value={item?.testName}
                                  label="Test Name"
                                  readOnly={true}
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  value={item?.category?.categoryName}
                                  readOnly={true}
                                  label="Category"
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group" key={item._id}>
                                <label className="col-form-label">
                                  {" "}
                                  Method:{" "}
                                </label>
                                <Select
                                  name="method"
                                  placeholder="Select Method"
                                  value={
                                    testData.method
                                      ? { label: testData.method }
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleTestProfileChange(
                                      e,
                                      "method",
                                      profile._id,
                                      item._id,
                                    )
                                  }
                                  isDisabled={!canEditProfileTest}
                                  options={getProfileMethods(
                                    profile?.profileName,
                                  )?.map((serviceMode) => ({
                                    value: serviceMode.value,
                                    label: serviceMode.label,
                                  }))}
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "14rem",
                                      overflowY: "auto",
                                    }),
                                  }}
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group" key={item._id}>
                                <InputText
                                  name="value"
                                  value={testData.value || ""}
                                  onChange={(e) =>
                                    handleTestProfileChange(
                                      e,
                                      "value",
                                      profile._id,
                                      item._id,
                                    )
                                  }
                                  label="Value"
                                  placeholder={"Value"}
                                  readOnly={!canEditProfileTest}
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  readOnly={true}
                                  label="Low Value"
                                  value={lowRange}
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  readOnly={true}
                                  label="High Value"
                                  value={highRange}
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  value={item?.reference_range_details}
                                  label="Reference Range"
                                  readOnly={true}
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  value={item?.units}
                                  readOnly={true}
                                  label="Units"
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group" key={item._id}>
                                <label className="col-form-label">
                                  Received Status:
                                </label>
                                <Select
                                  name="receivedStatus"
                                  placeholder="Select Status"
                                  value={
                                    testData.receivedStatus
                                      ? { label: testData.receivedStatus }
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleTestProfileChange(
                                      e,
                                      "receivedStatus",
                                      profile._id,
                                      item._id,
                                    )
                                  }
                                  isDisabled={!canEditProfileTest}
                                  options={
                                    receivedStatus &&
                                    receivedStatus?.map((serviceMode) => ({
                                      value: serviceMode.value,
                                      label: serviceMode.label,
                                    }))
                                  }
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "14rem",
                                      overflowY: "scroll",
                                    }),
                                  }}
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group" key={item._id}>
                                <label className="col-form-label">
                                  Reporting Status:
                                </label>
                                <Select
                                  name="reportingStatus"
                                  placeholder="Select Status"
                                  value={
                                    testData.reportingStatus
                                      ? { label: testData.reportingStatus }
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleTestProfileChange(
                                      e,
                                      "reportingStatus",
                                      profile._id,
                                      item._id,
                                    )
                                  }
                                  isDisabled={!canEditProfileTest}
                                  options={
                                    reportingStatus &&
                                    reportingStatus?.map((serviceMode) => ({
                                      value: serviceMode.value,
                                      label: serviceMode.label,
                                    }))
                                  }
                                  styles={{
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "14rem",
                                      overflowY: "auto",
                                    }),
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })} */}

                {/* URINE R/M Custom UI */}
                {profile?.profileName?.toLowerCase().includes("urine r/m") && (
                  <UrineRMProfile
                    profile={profile}
                    testMap={testMap}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                )}
                {profile?.profileName?.toLowerCase().includes("stool r/m") && (
                  <StoolRMProfile
                    profile={profile}
                    testMap={testMap}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                )}
                {profile?.profileName
                  ?.toLowerCase()
                  .includes("synovial fluid analysis") && (
                  <SynovialFluidProfile
                    profile={profile}
                    testMap={testMap}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                )}
                {profile?.profileName
                  ?.toLowerCase()
                  .includes("ps comments") && (
                  <PeripheralSmearProfile
                    profile={profile}
                    testMap={testMap}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                )}
                {profile?.profileName?.toLowerCase().includes("fnac") && (
                  <FnacProfile
                    profile={profile}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                )}
                {profile?.profileName?.toLowerCase().includes("widal") && (
                  <WidalProfile
                    profile={profile}
                    comment={currentProfile?.comment ?? profile?.comment}
                    testMap={testMap}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                )}
                {profile?.profileName
                  ?.toLowerCase()
                  .includes("seminal fluid analysis") && (
                  <SemenAnalysisProfile
                    profile={profile}
                    testMap={testMap}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                )}
                {profile?.profileName?.toLowerCase().includes("cbc") && (
                  <CBCProfile
                    profile={profile}
                    testMap={testMap}
                    handleTestProfileChange={handleTestProfileChange}
                    getProfileMethods={getProfileMethods}
                  />
                )}
                {(profile?.profileName
                  ?.toLowerCase()
                  .includes("dengue - rapid test") ||
                  profile?.profileName
                    ?.toLowerCase()
                    .includes("dengue profile") ||
                  profile?.profileName
                    ?.toLowerCase()
                    .includes("typhoid profile") ||
                  profile?.profileName
                    ?.toLowerCase()
                    .includes("mp (malaria parasite ict)")) && (
                  <DengueProfile
                    profile={profile}
                    testMap={testMap}
                    handleTestProfileChange={handleTestProfileChange}
                  />
                )}

                {/* ONLY FOR NON URINE r/m and stool r/m) */}
                {!profile?.profileName?.toLowerCase().includes("urine r/m") &&
                  !profile?.profileName?.toLowerCase().includes("stool r/m") &&
                  !profile?.profileName
                    ?.toLowerCase()
                    .includes("dengue - rapid test") &&
                  !profile?.profileName
                    ?.toLowerCase()
                    .includes("dengue profile") &&
                  !profile?.profileName
                    ?.toLowerCase()
                    .includes("typhoid profile") &&
                  !profile?.profileName
                    ?.toLowerCase()
                    .includes("mp (malaria parasite ict)") &&
                  !profile?.profileName
                    ?.toLowerCase()
                    .includes("synovial fluid analysis") &&
                  !profile?.profileName
                    ?.toLowerCase()
                    .includes("ps comments") &&
                  !profile?.profileName?.toLowerCase().includes("fnac") &&
                  !profile?.profileName?.toLowerCase().includes("widal") &&
                  !profile?.profileName?.toLowerCase().includes("cbc") &&
                  !profile?.profileName
                    ?.toLowerCase()
                    .includes("seminal fluid analysis") &&
                  profile?.tests &&
                  profile?.tests?.map((item, index) => {
                    const isCulture = isSputumCulture(profile?.profileName);

                    let highRange, lowRange;
                    if (item?.patientId?.userId?.age?.year < 10) {
                      highRange = item?.ihigh_range;
                      lowRange = item?.ilow_range;
                    } else {
                      if (item?.patientId?.userId?.gender === "Male") {
                        highRange = item.mhigh_range;
                        lowRange = item.mlow_range;
                      } else if (item.patientId?.userId?.gender === "Female") {
                        highRange = item.fhigh_range;
                        lowRange = item.flow_range;
                      } else {
                        highRange = item.high_range;
                        lowRange = item.low_range;
                      }
                    }

                    const testData = testMap.get(item._id) || {};
                    const isAbgTest =
                      item?.testName?.toLowerCase().includes("abg") ||
                      item?.testName
                        ?.toLowerCase()
                        .includes("average blood glucose");

                    const canEditProfileTest =
                      isOwner ||
                      (item?.sourceType === "outSource" &&
                        String(
                          item?.labForOutsource?._id ||
                            item?.unRegisteredlabForOutsource?._id,
                        ) === String(loggedInClinicId)) ||
                      (profile?.sourceType === "outSource" &&
                        String(
                          profile?.labForOutsource?._id ||
                            profile?.unRegisteredlabForOutsource?._id,
                        ) === String(loggedInClinicId));

                    return (
                      <div className={styles.testAndProfileWrapper} key={index}>
                        {isCulture ? (
                          <>
                            <div className={styles["inputWrapper"]}>
                              <InputText
                                value={item?.testName}
                                label="Test Name"
                                readOnly={true}
                              />
                            </div>

                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <label className="col-form-label">Result</label>
                                <Select
                                  name="value"
                                  placeholder="Select Result"
                                  value={
                                    testData.value
                                      ? { label: testData.value }
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleTestProfileChange(
                                      e,
                                      "value",
                                      profile._id,
                                      item._id,
                                    )
                                  }
                                  isDisabled={!canEditProfileTest}
                                  options={[
                                    {
                                      value: "SENSITIVE",
                                      label: "SENSITIVE",
                                    },
                                    {
                                      value: "INTERMEDIATE",
                                      label: "INTERMEDIATE",
                                    },
                                    {
                                      value: "RESISTANT",
                                      label: "RESISTANT",
                                    },
                                  ]}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {/* SAME EXISTING CODE (NO CHANGE) */}
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  value={item?.testName}
                                  label="Test Name"
                                  readOnly={true}
                                />
                              </div>
                            </div>

                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  value={item?.category?.categoryName}
                                  readOnly={true}
                                  label="Category"
                                />
                              </div>
                            </div>

                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <InputText
                                  value={item?.testMethod?.name}
                                  readOnly={true}
                                  label="Method"
                                />
                              </div>
                            </div>

                            <div className={styles["inputWrapper"]}>
                              <div className="form-group" key={item._id}>
                                <InputText
                                  name="value"
                                  className="lab-value"
                                  value={
                                    // 🔹 LFT
                                    isLFT &&
                                    item?.testName?.toLowerCase() ===
                                      "bilirubin indirect"
                                      ? isNaN(indirect)
                                        ? ""
                                        : indirect
                                      : isLFT &&
                                          item?.testName?.toLowerCase() ===
                                            "globulin"
                                        ? globulin2
                                        : isLFT &&
                                            item?.testName?.toLowerCase() ===
                                              "alb/glb ratio"
                                          ? agratio2
                                          : // 🔹 LIPID
                                            isLipid &&
                                              item?.testName?.toLowerCase() ===
                                                "ldl"
                                            ? ldl2
                                            : isLipid &&
                                                item?.testName?.toLowerCase() ===
                                                  "vldl"
                                              ? vldl2
                                              : isLipid &&
                                                  item?.testName?.toLowerCase() ===
                                                    "chol/hdl ratio"
                                                ? cholHdl
                                                : isLipid &&
                                                    item?.testName?.toLowerCase() ===
                                                      "ldl/hdl ratio"
                                                  ? ldlHdl
                                                  : isHba1c && isAbgTest
                                                    ? abg
                                                    : testData.value || ""
                                  }
                                  onChange={(e) =>
                                    handleTestProfileChange(
                                      e,
                                      "value",
                                      profile._id,
                                      item._id,
                                    )
                                  }
                                  label="Value"
                                  readOnly={
                                    (isLFT &&
                                      (item?.testName?.toLowerCase() ===
                                        "bilirubin indirect" ||
                                        item?.testName?.toLowerCase() ===
                                          "globulin" ||
                                        item?.testName?.toLowerCase() ===
                                          "alb/glb ratio")) ||
                                    (isLipid &&
                                      (item?.testName?.toLowerCase() ===
                                        "ldl" ||
                                        item?.testName?.toLowerCase() ===
                                          "vldl" ||
                                        item?.testName?.toLowerCase() ===
                                          "chol/hdl ratio" ||
                                        item?.testName?.toLowerCase() ===
                                          "ldl/hdl ratio")) ||
                                    (isHba1c && isAbgTest)
                                      ? true
                                      : !canEditProfileTest
                                  }
                                />
                              </div>
                            </div>
                            <div className={styles["inputWrapper"]}>
                              <div className="form-group">
                                <label className="col-form-label">
                                  Is NABL Approved
                                </label>

                                <Select
                                  name="isNABL"
                                  value={{
                                    value: testData?.isNABL || "No",
                                    label: testData?.isNABL || "No",
                                  }}
                                  onChange={(e) =>
                                    handleTestProfileChange(
                                      e,
                                      "isNABL",
                                      profile._id,
                                      item._id,
                                    )
                                  }
                                  isDisabled={!canEditProfileTest}
                                  options={yesNoOptions}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "15px",
                    marginBottom: "15px",
                  }}
                >
                  <div style={{ width: "250px" }}>
                    <InputText
                      value={profile?.testSampleType?.name}
                      readOnly={true}
                      label="Sample Type"
                      style={{
                        fontWeight: "500",
                        minWidth: "110px",
                        marginBottom: "0px",
                      }}
                    />
                  </div>
                </div>
                {isSputumCulture(profile?.profileName) && (
                  <div style={{ marginTop: "12px" }}>
                    <div style={rowStyle}>
                      <label style={labelStyle}>Organism</label>

                      <InputText
                        name="organism"
                        value={
                          currentProfile?.organism ?? profile?.organism ?? ""
                        }
                        onChange={(e) =>
                          handleTestProfileChange(e, "organism", profile._id)
                        }
                        style={textareaStyle}
                      />
                    </div>

                    {/* Colony Count */}
                    <div style={rowStyle}>
                      <label style={labelStyle}>Colony Count</label>

                      <InputText
                        name="colonyCount"
                        value={
                          currentProfile?.colonyCount ??
                          profile?.colonyCount ??
                          ""
                        }
                        onChange={(e) =>
                          handleTestProfileChange(e, "colonyCount", profile._id)
                        }
                        style={textareaStyle}
                      />
                    </div>

                    {/* Comment */}
                    <div style={rowStyle}>
                      <label style={labelStyle}>Comment :</label>

                      <textarea
                        value={
                          currentProfile?.comment ?? profile?.comment ?? ""
                        }
                        onChange={(e) =>
                          handleTestProfileChange(e, "comment", profile._id)
                        }
                        rows={2}
                        style={textareaStyle}
                      />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default TestAndProfile;
